import {
  CarrierConnectionTestAddressSchema,
  CarrierConnectionTestResultSchema,
} from "@redotech/redo-fulfillment-carrier-account-common/connection-test";
import * as z from "zod";

export const testCarrierAccountConnection = {
  name: "testCarrierAccountConnection" as const,
  input: z.object({
    carrierAccountId: z.string(),
    fromAddress: CarrierConnectionTestAddressSchema.nullish(),
    toAddress: CarrierConnectionTestAddressSchema.nullish(),
    saveFromAddress: z.boolean().nullish(),
  }),
  output: CarrierConnectionTestResultSchema,
};
